var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":_vm.type,"size":_vm.size,"icon":_vm.icon,"native-type":_vm.nativeType,"loading":_vm.loading,"disabled":_vm.disabled,"plain":_vm.plain,"round":_vm.round,"circle":_vm.circle},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }